module.exports = __webpack_public_path__ + "fonts/Roboto-Thin.66209ae0.ttf";